export const Env = {
  baseURL: process.env['NEXT_PUBLIC_BASE_URL']!,
};
